<template>
  <div
    class="page"
    :class="{
      'page-width-navbar': showNavbar
    }"
    v-bind="$attrs"
    ref="pageRef"
  >
    <page-header
      v-if="showHeader"
      :routes="routes"
      :logo-url="logoUrl"
      :showLogo="showLogo"
      :show-language="showLanguage"
    />
    <Navbar
      :show-search="showSearch"
      v-if="showNavbar"
      @on-search="handleSearch"
      :fixed="navFixed"
      :locationDisabled="locationDisabled"
      :routes="routes"
      :showBreadcrumb="showBreadcrumb"
      :show-language="showLanguage"
    />
    <div
      class="wrapper"
      :style="{ paddingTop: `${paddingTop}px`, ...wrapperStyle }"
    >
      <slot />
      <component v-if="footer" :is="footer.Component" v-bind="footer.props" />
    </div>
    <ConfigConfirmation
      v-model:show="showCustomConfirmationPop"
      :save-config="true"
      :show-email-input="false"
      :button-text="t('shared.common.save')"
    />
    <component
      v-for="(item, index) in CommonComponents"
      :key="index"
      :is="item.component"
      v-bind="item.props"
    />
  </div>
</template>
<script setup>
// import { storeToRefs } from "pinia";
import ConfigConfirmation from "@booking/order/ConfigConfirmation.vue";
import { computed, onBeforeUnmount, ref } from "vue";
import { useI18n } from "vue-i18n";
import bus from "vue3-eventbus";

import { useChannelStoreHook } from "@/store/modules/channel";

import { useCustomComponent } from "../hooks/useCustomComponent";
import { useYChannelStoreHook } from "../store/channel";
import { loadChannelComponent } from "../utils/loadChannelComponent";
import PageHeader from "./components/Header.vue";
import Navbar from "./components/Navbar.vue";
loadChannelComponent("Footer", import.meta.url).then(res => {
  footer.value = res;
});
const props = defineProps({
  routes: {
    type: Array,
    default: () => []
  },
  showSearch: {
    type: Boolean,
    default: false
  },
  showNavbar: {
    type: Boolean,
    default: true
  },
  navFixed: {
    type: Boolean,
    default: true
  },
  showHeader: {
    type: Boolean,
    default: false
  },
  showBreadcrumb: {
    type: Boolean,
    default: false
  },
  wrapperStyle: {
    type: Object,
    default: () => ({})
  },
  filterMethod: {
    type: Function
  },
  locationDisabled: {
    type: Boolean,
    default: false
  },
  logoUrl: {
    type: String,
    default: ""
  },
  showLogo: {
    type: Boolean,
    default: true
  }
});

const { t } = useI18n();

const { component: CommonComponents } = useCustomComponent("CommonComponents");

const pageRef = ref(null);
const footer = ref();

const showCustomConfirmationPop = ref(false);

const yChannelStore = useYChannelStoreHook();
const ChannelStore = useChannelStoreHook();

const showLanguage = computed(() => {
  return (
    yChannelStore.configs?.showLanguages !== false &&
    !["hotelux", "hoteluxjp"].includes(ChannelStore?.channel?.key)
  );
});

const handleSearch = () => {
  if (props?.filterMethod) {
    props?.filterMethod();
  }
};

const paddingTop = computed(() => {
  let value = 80;
  if (props.showBreadcrumb) {
    value = 110;
  }
  return value;
});

const onShow = () => {
  showCustomConfirmationPop.value = true;
};

bus.on("showCustomConfirmationPop", onShow);

onBeforeUnmount(() => {
  bus.off("showCustomConfirmationPop", onShow);
});

defineExpose({
  pageRef
});
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  overflow: auto;
  position: relative;
}
.wrapper {
  // max-width: 1920px;
  min-width: 1080px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  // padding-top: 112px;
}
</style>
